module.exports = __webpack_public_path__ + "files/c856ad408ea09f70bfd666e02d60f69b.png";